export default __webpack_public_path__ + "static/media/burn.cfee3da0.svg";